export const spinalCase = word =>
  word
    .replace(/\s+/g, "-")
    .replace(/'/g, "-")
    .replace(/\(/g, "-")
    .replace(/\)/g, "-")
    .toLowerCase();

